import React, { useEffect, useRef, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Box, LayerBottom, Layer, Scroller, Logo } from 'components'
import Lib from 'library'
import styles from './index.module.css'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { influencerState } from './states'


const InfluencerMy = () => {

	const App = useApp()
	const navigate = useNavigate()
	const location = useLocation()


	const inputRef = useRef(); // 
	const noMore = useRef(false);
	const [showLayer, setShowLayer] = useState(false)
	const [detailLayer, setDetailLayer] = useState(false)

	// const [imgBase64, setImgBase64] = useState(""); // 파일 base64
	const [imgFile, setImgFile] = useState("");	// 파일	등록된 이미지 파일
	const [viewImgFile, setViewImgFile] = useState(null); // 화면에 보여지는 등록 파일	
	const [portfolioData, setPortfolioData] = useState(); // 포트폴리오 리스트
	const [infiniteN, setInfiniteN] = useState(0); // 무한 스크롤 숫자
	const [target, setTarget] = useState(""); // 페이지 가장 하단 target
	const myInfoData = useRecoilValue(influencerState) // 유저 정보
	const [commentText, setCommnetText] = useState('') // 유저가 등록한 코멘트
	const [applyItem, setApplyItem] = useState() // 리스트 클릭시 해당 item Lyaer에 전달
	const [detailItem, setDetailItem] = useState() // 상세 화면 클릭시 해당 item Lyaer에 전달
	const [mode, setMode] = useState('I')  // 유저가 등록 상태인지  수정 상태인지 
	const [subscList, setSubscList] = useState() // 구독한 인플루언서 목록
	const [inflLankData, setInflLankData] = useState(0)  // 구독한수가 많은 인플루언서 리스트
	const moreSliceN = 3; // 구독수가 많은 인플루언서 더보기 버튼 노출 개수
	const [influMoreBtn, setInfluMoreBtn] = useState(moreSliceN) // 더보기 버튼
	const [influLength, setInfluLength] = useState(0)
	const [aplyMydata, setAplyMydata] = useState()

	const [tabState, setTabState] = useState(true)  // tab 활성화  true 내포트폴리오  false 구독중 인플루 언서


	// 정지 Layer
	const [banLayer, setBanLayer] = useState(false)
	const banCloseLayer = () => {
		setBanLayer(false)
	}

	// 상세 페이지
	const assetMoreSliceN = 3;
	const [assetMoreBtn, setAssetMoreBtn] = useState(assetMoreSliceN)
	const [assetLength, setAssetLength] = useState(0)
	const [assetDetail, setAssetDetail] = useState()


	const closeLayer = () => {
		setShowLayer(false)
	}

	const detailCloseLayer = () => {
		setDetailLayer(false)
	}

	// 상세페이지
	const openDetailLayer = (item, mode) => {
		setDetailLayer(true)
		setDetailItem(item);
		setMode(mode);
		Lib.post(`/api/infl/lst/dlyprtfl/dtl`, {
			de: item.de,
			mbId: myInfoData.mbId
		}, data => {
			setAssetLength(Math.ceil(data.length / assetMoreSliceN));
			setAssetDetail(data.slice(0, assetMoreBtn))
		});
	}

	// 더보기 버튼
	const assetMoreButton = () => {
		setAssetMoreBtn(assetMoreBtn + assetMoreSliceN)
	}

	// 더보기 버튼
	const assetMorebtnBox = () => {
		if (assetLength > 1 && (assetMoreBtn / assetMoreSliceN) < assetLength) {
			return (
				<div className="padding pb_50" onClick={assetMoreButton}>
					<Button className="btn btn--big">+ 더보기</Button>
				</div>
			)
		} else {
			return ''
		}
	}

	// 포트폴리오별 상세 자산 목록
	useEffect(() => {
		if (!detailItem) { return  }
		Lib.post(`/api/infl/lst/dlyprtfl/dtl`, {
			de: detailItem ? detailItem.de : '',
			mbId: myInfoData ? myInfoData.mbId : ''
		}, data => {
			setAssetLength(Math.ceil(data.length / assetMoreSliceN));
			setAssetDetail(data.slice(0, assetMoreBtn))
		});
	}, [assetMoreBtn])

	const openLayer = (item, mode) => {
		// 유저가 정지 상태일때 로직
		if (myInfoData.stopYn === 'Y') {
			setBanLayer(true)
			return false;
		}
		setMode(mode)
		setApplyItem(item);
		setShowLayer(true)
		setCommnetText(item.cmnt)
	}

	const handleChangeFile = (event) => {
		let modifyImg = document.querySelector('.modify-img')
		if (mode === 'U' && modifyImg) {
			modifyImg.style.display = 'none'
		}
		let reader = new FileReader();
		reader.onloadend = () => {
			// 2. 읽기가 완료되면 아래코드가 실행됩니다.
			const base64 = reader.result;
			if (base64) {
				// setImgBase64(base64.toString()); // 파일 base64 상태 업데이트
			}
		}
		if (event.target.files[0]) {
			reader.readAsDataURL(event.target.files[0]); // 1. 파일을 읽어 버퍼에 저장합니다.
			setViewImgFile(URL.createObjectURL(event.target.files[0]))  // 파일 상태 업데이트
			setImgFile(event.target.files[0])
		}
	}

	const onbuttonClick = (event) => {
		event.preventDefault();
		inputRef.current.click();
	}

	// 파일 삭제
	const deleteFileImage = () => {
		URL.revokeObjectURL(viewImgFile);
		setViewImgFile("");
		setImgFile("")
	};

	// 수정 파일 삭제 
	const deleteModifyImage = () => {
		setViewImgFile("");
		setImgFile("")
		document.querySelector('.modify-img').style.display = 'none'
	};

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />
		})

		App.setShowNav(false)
		App.setMainClass("white")

		const influMore = location.state?.influMore
		if (influMore === false) {
			setTabState(false)
		}

		//마이데이터 연동 여부 확인
		Lib.get(`/api/data/v2/lnkup/chck`, data => {
			setAplyMydata(data)
		})
	}, [])


	useEffect(() => {
		if (infiniteN === 0) { return  }
		fetchItems();
	}, [infiniteN])


	const fetchItems = () => {
		Lib.post(`/api/infl/lst/dlyprtfl`, {
			mbId: '',
			pageNo: infiniteN
		}, data => {
			if (data.length < 20) {
				noMore.current = true
			}
			if (data.length === 0) {
				noMore.current = true
			} else {
				if (infiniteN === 1) {
					setPortfolioData(data);
				} else if (infiniteN > 1) {
					setPortfolioData((preState) => preState.concat(data));
				}
			}

		});
	}

	// 무한스크롤 동작시 실행
	const onIntersect = ([entry]) => {
		if (entry.isIntersecting) {
			// // 데이터를 가져오는 부분
			if (noMore.current === false) {
				setInfiniteN(prev => prev + 1)
			}
		}
	};

	const onChangeYear = (changeToday) => {
		let s = changeToday.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
		const newDay = new Date(s);
		// 요일 찾기
		function getDayInfo() {
			// eslint-disable-next-line no-array-constructor
			var week = new Array('(일)', '(월)', '(화)', '(수)', '(목)', '(금)', '(토)');
			var today = newDay.getDay();
			var todayLabel = week[today];
			return todayLabel;
		}
		return getDayInfo();
	}

	const onDataAlign = (day, index) => {
		Lib.post(`/api/infl/lst/dlyprtfl`, {
			mbId: '',
			pageNo: index
		}, data => {
			let changeData = data.find((item) => {
				return item.de === day
			})
			if (changeData) {
				const setData = portfolioData.map(
					item => item.de === day
						? {
							de: changeData.de,
							blncAmt: changeData.blncAmt,
							cmnt: changeData.cmnt,
							cmntImgFileId: changeData.cmntImgFileId,
							dfrnAmt: changeData.dfrnAmt
						}
						: item
				);

				setPortfolioData(setData)
			}
		});
	};

	useEffect(() => {
		// 구독한 인플루언서 목록
		Lib.post(`/api/infl/lst/sbscr`, {
			mbId: ''
		}, data => {
			setSubscList(data);
		});
	}, [])

	// 구독취소
	const onSbscCancle = (item) => {
		Lib.post(`/api/infl/unsbscr`, {
			unsbscrMbId: item.mbId
		}, data => {
			Lib.post(`/api/infl/lst/sbscr`, {
				mbId: ''
			}, data => {
				setSubscList(data);
			});
		});
	}

	useEffect(() => {
		Lib.post(`/api/infl/lst/rank`, data => {
			setInfluLength(Math.ceil(data.length / moreSliceN));
			setInflLankData(data.slice(0, influMoreBtn))
		});
	}, [influMoreBtn])

	// 구독전체취소
	const onSbscAllCancle = () => {

		const onCancle = () => {
			Lib.post(`/api/infl/unsbscr`, {
				unsbscrMbId: ''
			}, data => {
				Lib.post(`/api/infl/lst/sbscr`, {
					mbId: ''
				}, data => {
					setSubscList(data);
				});
			});
		}

		App.showAlert({
			msg: `전체취소시 구독중인<br/> 모든 인플루언서를 구독취소합니다.<br/>그래도 진행하시겠습니까?`,
			type: "bottom",
			closeBtn: true,
			confirm: true,
			onOk: () => onCancle(),
			ok: "확인",
			cancel: "취소"
		})
	}

	// 무한 스크롤 설정
	useEffect(() => {
		let observer;
		if (target) {
			// callback 함수, option
			observer = new IntersectionObserver(onIntersect, {
				threshold: 0.4,
			});
			observer.observe(target); // 타겟 엘리먼트 지정
		}
		return () => observer && observer.disconnect();
	}, [target]);


	// 코멘트 텍스트
	const onComentText = (e) => {
		setCommnetText(e.target.value);
	}

	// 등록된 포트폴리오 삭제
	const onComentDelete = () => {

		const onDelete = async () => {
			const fd = new FormData();
			fd.append("de", applyItem.de)
			fd.append("mode", 'D')
			await axios.post('/api/infl/upd/cmnt', fd, {
				headers: {
					"Content-Type": `multipart/form-data;`,
				},
			})
				.then((response) => {
					if (response.data.code === "S000") {
						onDataAlign(applyItem.de, infiniteN);
						setShowLayer(false)
						setDetailLayer(false)
					} else {
						alert(`[${response.data.code}] ${response.data.msg}`)
					}
				})
				.catch((error) => {
					// 예외 처리
					console.log("error", error);
				})
		}

		App.showAlert({
			msg: `코멘트,이미지를 삭제하면 복구할 수 없습니다.<br />그래도 진행하시겠습니까?`,
			type: "bottom",
			closeBtn: true,
			confirm: true,
			onOk: () => onDelete(),
			ok: "삭제하기",
			cancel: "취소"
		})
	}

	// 포트폴리오 등록
	const onApplyPortfolio = (item) => {
		if (commentText.length > 200) {
			App.showAlert('코멘트를 200자 이하로 작성해주세요.')
			return false;
		}
		if (mode === 'U' && commentText === '') {
			App.showAlert('코멘트 입력 내용이 없습니다.')
			return false;
		} else if (mode === 'U' && commentText === item.cmnt) {
			// [코멘트 입력여부만 체크하는 것이 맞음. 20221021]
			//App.showAlert('코멘트 수정된 내용이 없습니다.')
			//return false;
		}
		const fd = new FormData();
		if (imgFile) {
			fd.append("cmntImgFile", imgFile)
		}
		fd.append("de", item.de)
		fd.append("mode", mode)
		fd.append("cmnt", commentText)
		axios.post('/api/infl/upd/cmnt', fd, {
			headers: {
				"Content-Type": `multipart/form-data;`,
			},
		})
			.then((response) => {
				if (response.data.code === "S000") {
					onDataAlign(applyItem.de, infiniteN);
					setShowLayer(false)
					setViewImgFile("");
					setImgFile("");
					setDetailLayer(false)
				} else if (response.data.code === "E002") {
					App.showAlert('이미지,코멘드 내용이 없습니다.')
				} else {
					console.log(`[${response.data.code}] ${response.data.msg}`);
				}
			})
			.catch((error) => {
				// 예외 처리
				console.log("error", error);
			})
	}

	// 더보기 버튼
	const influMoreButton = () => {
		setInfluMoreBtn(influMoreBtn + moreSliceN)
	}

	// 구독자수가 많은 인플루언서
	const influMorebtnBox = () => {
		if (influLength > 1 && (influMoreBtn / moreSliceN) < influLength) {
			return (
				<div className="padding pb_50" onClick={influMoreButton}>
					<Button className="btn btn--big">+ 더보기</Button>
				</div>
			)
		} else {
			return ''
		}
	}

	// 유저 인플루언서 상세보기
	const onDetailView = (item) => {
		Lib.post(`/api/infl/inf`, {
			mbId: item.mbId
		}, data => {
			if (data.joinYn === 'N') {
				App.showAlert("해당 유저는 인플루언서 미참여 상태입니다.")
			} else if (data.mbStusCd === 'DRMNC') {
				App.showAlert("해당 유저는 휴먼 상태입니다.")
			} else if (data.mbStusCd === 'WTHDR') {
				App.showAlert("해당 유저는 탈퇴 상태입니다.")
			} else {
				if (item.mbId === App.user?.mbId) {
					navigate("/home/influencerMy", {
						state: {
							mbIdData: item,
							otherMbIdData: myInfoData,
						}
					})
				} else {
					navigate("/home/InfluencerOthers", {
						state: {
							mbIdData: item,
							otherMbIdData: myInfoData,
						}
					})
				}
			}
		})
	}

	// tab 클릭
	const ontabAction = (state) => {
		setTabState(state);
	}

	return (
		<div className="page">
			<div className="shadow">
				<div style={{ textAlign: "right", marginRight: "20px" }} ><Link to='/home/InfluencerResign'><span className="text-red link-top">인플루언서 철회</span></Link></div>
				{myInfoData && (
					<div className="padding">
						<div className="flex-align_center">
							<div className="img-box user-profile profile_80">
								{myInfoData && (
									<img src={"/images/profile/influencer_profile" + myInfoData.prflCd + ".svg"} alt="프로필 이미지" />
								)}
							</div>
							<div className="flex--item_1 ml_20">
								<div className="flex-justify_between align_center">
									<h3>{myInfoData.ncknm}</h3>
									<Link to='/home/profileModify'><span className="write-btn"><i className="icon icon_write mr_5" />수정</span></Link>
								</div>
								<p className="mt_5" style={{ fontSize: "1.2rem", color: "#999" }}>Since. {Lib.dateFormat(myInfoData.joinDe, ".")}</p>
								<div className="flex-align_center mt_10">
									<i className="tag tag-lg tag-green">#{myInfoData.ageGroup}대</i>
									<i className="tag tag-lg tag-green ml_10">#{myInfoData.gendr === 'M' ? '남성' : '여성'}</i>
								</div>
								<p className="mt_10 flex-align_center" style={{ fontSize: "1.2rem" }}><span className="text-blue">{myInfoData.sbscredCnt}명</span>이 구독중입니다.</p>
							</div>
						</div>
						<div className={`${styles["tag-wrap"]} mt_20`}>
							{/* {myInfoData.amt1001 > 10000 && <span>#은행잔고{myInfoData.amt1001 === '0' ? 0 : Lib.numberToKorean(myInfoData.amt1001)}원대</span>} */}
							{myInfoData.amt1001 > 10000 && <span>#은행잔고{(999999 > myInfoData.amt1001 && myInfoData.amt1001 > 10000) ? Lib.numberToKorean(Math.floor(myInfoData.amt1001 / 10000) * 10000) : Lib.numberToKorean(Math.floor(myInfoData.amt1001 / 100000) * 100000)}원대</span>}
							{myInfoData.amt1002 > 10000 && <span>#예금{(999999 > myInfoData.amt1002 && myInfoData.amt1002 > 10000) ? Lib.numberToKorean(Math.floor(myInfoData.amt1002 / 10000) * 10000) : Lib.numberToKorean(Math.floor(myInfoData.amt1002 / 100000) * 100000)}원대</span>}
							{myInfoData.amt1003 > 10000 && <span>#적금{(999999 > myInfoData.amt1003 && myInfoData.amt1003 > 10000) ? Lib.numberToKorean(Math.floor(myInfoData.amt1003 / 10000) * 10000) : Lib.numberToKorean(Math.floor(myInfoData.amt1003 / 100000) * 100000)}원대</span>}
						</div>
					</div>
				)}
			</div>
			<ul className={`${styles["display-tab"]}`}>
				<li className={`${tabState ? `${styles["on"]}` : ''}`} onClick={() => ontabAction(true)}><span>내포트폴리오</span></li>
				<li className={`${tabState ? '' : `${styles["on"]}`}`} onClick={() => ontabAction(false)}><span>구독중 인플루언서</span></li>
			</ul>
			<div className={`${styles["display-tab-content"]}`}>
				{tabState && tabState ?
					<>
						{
							aplyMydata && aplyMydata.hasLnkupData ?
								<div className="padding bg-violet">
									{portfolioData && portfolioData.map((item, index) => {
										const mode = "I"
										if (item.cmntImgFileId === '' && item.cmnt === '') {
											return (
												<div key={index} className="mb_20">
													<strong>{Lib.dateFormat(item.de, ".")} {onChangeYear(item.de)} </strong>
													<Box className="mt_10">
														<div className="balance" style={{ padding: "0 2rem" }} onClick={() => openDetailLayer(item, mode)}>
															{
																item.dfrnAmt === 0 ?
																	<span className="icon icon_balance_same" />
																	:
																	item.dfrnAmt > 0 ?
																		<span className="icon icon_balance_arrow_right" />
																		:
																		item.dfrnAmt < 0 ?
																			<span className="icon icon_balance_arrow_left" />
																			:
																			""
															}
															<ul className="balance-area">
																<li>
																	<span className={`icon ${item.dfrnAmt < 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
																	<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(item.blncAmt)}원</p>
																</li>
																<li>
																	<span className={`icon ${item.dfrnAmt > 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
																	<p className="price">{Lib.addComma(item.blncAmt - item.dfrnAmt)}원</p>
																</li>
															</ul>
														</div>
														<div className={`${styles["money-guide"]} mt_20`}>
															어제대비 <strong className={`${item.dfrnAmt >= 0 ? "text-red" : "text-blue"}`}>{item.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(item.dfrnAmt)} 원</strong>
														</div>
														<p className="guide-txt mt_20">* 오늘의 코멘트를 등록해보세요</p>
														<Button className="btn btn--md mt_20" onClick={() => openLayer(item, mode)}>등록</Button>
													</Box>
												</div>
											)
										} else {
											const mode = "U"
											if (item.cmntImgFileId === '') {
												return (
													<div key={index} className="mb_20">
														<strong>{Lib.dateFormat(item.de, ".")} {onChangeYear(item.de)} </strong>
														<span className="write-btn" style={{ color: "var(--main-color)", justifyContent: "right" }} onClick={() => openLayer(item, mode)}><i className="icon icon_write icon_write_blue mr_5" />수정</span>
														<Box className="mt_10">
															<div className="slider">
																<ul>
																	<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
																		<div className="balance" style={{ padding: "0 2rem" }} onClick={() => openDetailLayer(item, mode)}>
																			{
																				item.dfrnAmt === 0 ?
																					<span className="icon icon_balance_same" />
																					:
																					item.dfrnAmt > 0 ?
																						<span className="icon icon_balance_arrow_right" />
																						:
																						item.dfrnAmt < 0 ?
																							<span className="icon icon_balance_arrow_left" />
																							:
																							""
																			}
																			<ul className="balance-area">
																				<li>
																					<span className={`icon ${item.dfrnAmt < 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
																					<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(item.blncAmt)}원</p>
																				</li>
																				<li>
																					<span className={`icon ${item.dfrnAmt > 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
																					<p className="price">{Lib.addComma(item.blncAmt - item.dfrnAmt)}원</p>
																				</li>
																			</ul>
																		</div>
																	</li>
																</ul>
															</div>
															<div className={`${styles["money-guide"]} mt_20`}>
																어제대비 <strong className={`${item.dfrnAmt >= 0 ? "text-red" : "text-blue"}`}>{item.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(item.dfrnAmt)} 원</strong>
															</div>
															<p className="mt_20" style={{ textAlign: "justify", whiteSpace: "pre-line" }}>{item.cmnt}</p>
														</Box>
													</div>
												)
											} else {
												return (
													<div key={index} className="mb_20">
														<strong>{Lib.dateFormat(item.de, ".")} {onChangeYear(item.de)} </strong>
														<span className="write-btn" style={{ color: "var(--main-color)", justifyContent: "right" }} onClick={() => openLayer(item, mode)}><i className="icon icon_write icon_write_blue mr_5" />수정</span>
														<Box className="mt_10">
															<div className="slider">
																<ul>
																	<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
																		<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
																			<div className="balance" style={{ padding: "0 2rem" }} onClick={() => openDetailLayer(item, mode)}>
																				{
																					item.dfrnAmt === 0 ?
																						<span className="icon icon_balance_same" />
																						:
																						item.dfrnAmt > 0 ?
																							<span className="icon icon_balance_arrow_right" />
																							:
																							item.dfrnAmt < 0 ?
																								<span className="icon icon_balance_arrow_left" />
																								:
																								""
																				}
																				<ul className="balance-area">
																					<li>
																						<span className={`icon ${item.dfrnAmt < 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
																						<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(item.blncAmt)}원</p>
																					</li>
																					<li>
																						<span className={`icon ${item.dfrnAmt > 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
																						<p className="price">{Lib.addComma(item.blncAmt - item.dfrnAmt)}원</p>
																					</li>
																				</ul>
																			</div>
																		</li>
																		{item.cmntImgFileId && (
																			<li style={{ width: '100%' }} >
																				<img style={{ width: '100%', height: '10rem' }} src={`/api/comm/showImage/${item.cmntImgFileId}`} alt='' />
																			</li>
																		)}
																	</Scroller>
																</ul>
															</div>
															<div className={`${styles["money-guide"]} mt_20`}>
																어제대비 <strong className={`${item.dfrnAmt >= 0 ? "text-red" : "text-blue"}`}>{item.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(item.dfrnAmt)} 원</strong>
															</div>
															<p className="mt_20" style={{ textAlign: "justify", whiteSpace: "pre-line" }}>{item.cmnt}</p>
														</Box>
													</div>
												)
											}

										}
									})}
									{/* 무한 스크롤 타켓 위치 */}
									<div ref={setTarget}></div>
								</div>
								:
								<div className="center-cont py_80">
									<span className="icon icon_no_data" />
									<p className="mt_20">발행된 데이터가 없습니다.</p>
								</div>
						}
					</>
					:
					<div>
						<div className="shadow">
							<div className="padding">
								<div className="flex-justify_between align_center">
									<h3>구독중 인플루언서 <span className="text-blue">{subscList && subscList.length}</span></h3>
									{subscList && subscList.length === 0 ? '' : <span className="flex-align_center text-red" onClick={() => onSbscAllCancle()}><i className="icon icon_trash_red mr_5" />전체 구독취소</span>}
								</div>
								{/* 데이터 있을 때 */}
								<ul className={`${styles["influencer-view"]} mt_30`}>
									{subscList && subscList.length > 0 ? subscList.map((item, index) => {
										return (
											<li key={index}>
												<div className={styles["img-wrap"]}>
													<div className="img-box user-profile profile_60" onClick={() => onDetailView(item)}>
														<img src={"/images/profile/influencer_profile" + item.prflCd + ".svg"} alt="프로필 이미지" />
													</div>
													<span className="icon icon_influencer_close" onClick={() => onSbscCancle(item)} />
												</div>
												<span className="ellipsis">{item.ncknm}</span>
											</li>
										)
									}) :
										<div className="center-cont py_50">
											<span className="icon icon_no_data" />
											<p className="mt_20">구독중인 인플루언서가 없어요!<br />인플루언서를 구독해보세요!</p>
										</div>
									}
								</ul>
							</div>
						</div>

						{inflLankData && inflLankData.length > 0 ? (
							<>
								<h3 className="padding pb_20">구독수가 많은 인플루언서</h3>
								<ul className={`${styles["influencer-list"]} list-bg`}>
									{inflLankData.map((item, index) => {
										let cssMedal = '';
										if (index === 0) cssMedal = 'icon_medal_gold'
										if (index === 1) cssMedal = 'icon_medal_silver'
										if (index === 2) cssMedal = 'icon_medal_bronze'
										return (
											<li key={index}>
												<div className="flex-align_center" onClick={() => onDetailView(item)}>
													<span className={styles.number}>{item.rank}</span>
													<div className="flex-align_center ml_20">
														<div className={styles["user"]}>
															<div className="img-box user-profile profile_50">
																<img src={"/images/profile/influencer_profile" + item.prflCd + ".svg"} alt="프로필 이미지" />
															</div>
															<i className={`icon ${cssMedal}`} />
														</div>
														<div className={`${styles.profile} ml_10`}>
															<p>{item.ncknm}</p>
															<span className="flex-align_center mt_5"><span className="text-blue">{item.sbscrCnt}명</span>이 구독중</span>
														</div>
													</div>
												</div>
												{/* {myInfoData && myInfoData.mbId === item.mbId ? '' : item.sbscrYn === 'Y' ? <span className={`${styles.choose} ${styles.cancel}`} onClick={()=> onSbscCancle(item)}>구독취소</span> : <span className={`${styles.choose}`} onClick={()=> onSbsc(item)}>+ 구독하기</span>} */}
											</li>
										)
									})}

								</ul>
								{influMorebtnBox()}
							</>
						) : (
							<>
								{/* 데이터 없을 때 */}
								<div className="center-cont py_80">
									<span className="icon_influencer_smile" />
									<p className="mt_15" style={{ fontSize: "1.6rem" }}>첫번째 인플루언서가<br />되어보세요!</p>
								</div>
							</>
						)}
					</div>
				}
			</div>
			<EnterLayer show={showLayer} closeLayer={closeLayer} handleChangeFile={handleChangeFile} imgFile={imgFile} inputRef={inputRef} onbuttonClick={onbuttonClick} deleteFileImage={deleteFileImage} deleteModifyImage={deleteModifyImage} onComentText={onComentText} commentText={commentText} onApplyPortfolio={onApplyPortfolio} applyItem={applyItem} onChangeYear={onChangeYear} viewImgFile={viewImgFile} mode={mode} onComentDelete={onComentDelete} />
			<DetailLayer show={detailLayer} closeLayer={detailCloseLayer} detailItem={detailItem} myInfoData={myInfoData} openLayer={openLayer} mode={mode} assetDetail={assetDetail} assetMorebtnBox={assetMorebtnBox} DetailPortpolio={DetailPortpolio} onChangeYear={onChangeYear} />
			<BanDetailTip show={banLayer} closeLayer={banCloseLayer} myInfoData={myInfoData} />
		</div>
	)
}

const EnterLayer = ({ show, closeLayer, handleChangeFile, imgFile, inputRef, onbuttonClick, deleteFileImage, onComentText, commentText, onApplyPortfolio, applyItem, onChangeYear, viewImgFile, mode, deleteModifyImage, onComentDelete }) => {
	return (
		<LayerBottom title={mode && mode === 'I' ? '코멘트 등록' : '코멘트 수정'} show={show} closeLayer={closeLayer} outside={
			<div className="button-group">
				<Button className="btn btn--big btn-layer" onClick={() => onApplyPortfolio(applyItem)}>{mode && mode === 'I' ? '등록하기' : '수정하기'}</Button>
			</div>
		}>
			<div>
				{mode && mode === "U" && (
					<div className="flex-justify_end" onClick={() => onComentDelete()}>
						<span className="text-red">삭제</span>
					</div>
				)}
				<div className="slider mt_10">
					<ul className={styles["box-line"]}>
						{DetailPortpolio(applyItem)}
					</ul>
				</div>

				<div className={`${styles.inputFileBox} mb_20`}>
					{/*<input ref={inputRef} accept='image/jpg,image/png,image/jpeg,image/gif,image/*' className={styles.inputFile} type="file" capture name="imgFile" id="imgFile" onChange={handleChangeFile} />*/}
					<input ref={inputRef} accept='image/*' className={styles.inputFile} type="file" name="imgFile" id="imgFile" onChange={handleChangeFile} />
					<Button className="btn btn--big mt_20" onClick={onbuttonClick}>+ 이미지 추가하기</Button>
				</div>
				<div className={styles.inputImgBox}>
					{viewImgFile && (
						<>
							<img
								alt="sample"
								src={viewImgFile}
								style={{ margin: "auto", width: "100%", height: "15.5rem" }}
							/>
							<span onClick={deleteFileImage} className={`${styles.icon_close} icon_close Layer_withTitle__1qrYB`} />
						</>
					)}
					{applyItem && applyItem.cmntImgFileId && mode === 'U' ? (
						<div className='modify-img'>
							<img

								alt="sample"
								src={`/api/comm/showImage/${applyItem.cmntImgFileId}`}
								style={{ margin: "auto", width: "100%", height: "15.5rem" }}
							/>
							<span onClick={deleteModifyImage} className={`${styles.icon_close} icon_close Layer_withTitle__1qrYB`} />
						</div>
					) : ''}
				</div>
				<div className="mt_20 flex-align_center">
					{applyItem && (
						<strong className="mr_10">{Lib.dateFormat(applyItem.de, ".")} {onChangeYear(applyItem.de)}</strong>
					)}
					{applyItem && (
						<>
							어제대비<strong className={`${applyItem.dfrnAmt >= 0 ? "text-red" : "text-blue"} ml_5 `}>{applyItem.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(applyItem.dfrnAmt)} 원</strong>
						</>
					)}
				</div>
				<textarea placeholder="코멘트를 입력하세요" onChange={onComentText} value={commentText} maxLength={200} className="write-area mt_20" style={{ minHeight: "8rem" }} />
				<div className="count mt_5">{`(${commentText.length}/200)`}</div>
				<p className="guide-txt mt_10">코멘트 등록 시 비속어, 정치적 기타 등등 입력하면 운영진에 의해 강제 삭제됩니다. 운영정책을 확인하세요.</p>
			</div>
		</LayerBottom>
	)
}

const DetailPortpolio = (detailItem) => {
	if (!detailItem) { return false }
	if (detailItem.cmntImgFileId === '') {
		return (
			<li style={{ width: "100%" }}>
				<div className="balance" style={{ padding: "0 1rem" }}>
					{
						detailItem.dfrnAmt === 0 ?
							<span className="icon icon_balance_same" />
							:
							detailItem.dfrnAmt > 0 ?
								<span className="icon icon_balance_arrow_right" />
								:
								detailItem.dfrnAmt < 0 ?
									<span className="icon icon_balance_arrow_left" />
									:
									""
					}
					<ul className="balance-area">
						<li>
							<span className={`icon ${detailItem.dfrnAmt < 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
							<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(detailItem.blncAmt)}원</p>
						</li>
						<li>
							<span className={`icon ${detailItem.dfrnAmt > 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
							<p className="price">{Lib.addComma(detailItem.blncAmt - detailItem.dfrnAmt)}원</p>
						</li>
					</ul>
				</div>
			</li>
		)
	} else {
		return (
			<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
				<li style={{ width: "100%" }}>
					<div className="balance" style={{ padding: "0 1rem" }}>
						{
							detailItem.dfrnAmt === 0 ?
								<span className="icon icon_balance_same" />
								:
								detailItem.dfrnAmt > 0 ?
									<span className="icon icon_balance_arrow_right" />
									:
									detailItem.dfrnAmt < 0 ?
										<span className="icon icon_balance_arrow_left" />
										:
										""
						}
						{/* <span className="icon icon_balance_arrow" /> */}
						<ul className="balance-area">
							<li>
								<span className={`icon ${detailItem.dfrnAmt < 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
								<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(detailItem.blncAmt)}원</p>
							</li>
							<li>
								<span className={`icon ${detailItem.dfrnAmt > 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
								<p className="price">{Lib.addComma(detailItem.blncAmt - detailItem.dfrnAmt)}원</p>
							</li>
						</ul>
					</div>
				</li>
				{detailItem.cmntImgFileId !== '' && (
					<li style={{ width: '100%' }} >
						<img style={{ width: '100%', height: '10rem' }} src={`/api/comm/showImage/${detailItem.cmntImgFileId}`} alt='' />
					</li>
				)}
			</Scroller>
		)
	}
}

const DetailLayer = ({ show, closeLayer, openLayer, detailItem, myInfoData, assetDetail, assetMorebtnBox, DetailPortpolio, mode, onChangeYear }) => {
	return (
		<Layer title={'상세페이지'} show={show} closeLayer={closeLayer}>
			<div className="page padding">
				<div className="" style={{ borderBottom: '1px solid #d9d9d9' }}>
					<div className="mb_20">
						<h4><strong>{myInfoData && myInfoData.ncknm}</strong>님의<br />포트폴리오</h4>
						<div className="slider mt_10">
							<ul className={styles["box-line"]}>
								{DetailPortpolio(detailItem)}
							</ul>
						</div>
						<div className="mt_50">
							<div className="flex-justify_between align_center mt_30">
								<strong>{detailItem && Lib.dateFormat(detailItem.de, ".")}{detailItem && onChangeYear(detailItem.de)}</strong>
								<span className="write-btn" onClick={() => openLayer(detailItem, mode)}><i className="icon icon_write icon_write mr_5" />수정</span>
							</div>
							<div className="mt_10 flex-align_center" style={{ fontSize: "1.6rem" }}>어제대비<strong className={`${detailItem && detailItem.dfrnAmt >= 0 ? "text-red" : "text-blue"} ml_5 `}>{detailItem && detailItem.dfrnAmt >= 0 ? "+" : ""}{detailItem && Lib.addComma(detailItem.dfrnAmt)}원</strong></div>
							{detailItem && detailItem.cmnt !== '' && (
								<>
									<hr className="my_20" />
									<div style={{ whiteSpace: 'pre-line' }}>{detailItem.cmnt}</div>
								</>
							)}
						</div>
					</div>
				</div>
				{assetDetail && assetDetail.length > 0 ?
					<ul className={`${styles["bank-list"]} list-bg mt_40`}>
						{assetDetail.map((item, index) => {
							return (
								<li key={index}>
									<div className="flex-align_center">
										<div className="img-box img-symbol">
											<Logo code={item.insttCd} style={{ 'width': '4rem', 'height': '4rem' }} />
										</div>
										<span className="ml_10">{item.insttNm}</span>
									</div>
									<div>
										<p className={styles.price}>{Lib.addComma(item.blncAmt)}원</p>
										<span className={`${styles.info} ${item.dfrnAmt >= 0 ? "plus" : "minus"}`}>{item.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(item.dfrnAmt)}원</span>
									</div>
								</li>
							)
						})}
					</ul>
					: <div className='mt_20'>오늘은 어제대비 계좌잔액 변동이 없어요.</div>}
				{assetMorebtnBox()}
			</div>
		</Layer>
	)
}

// 정지계정인 회원이 수정 클릭했을 때 하단 레이어 나옴
const BanDetailTip = ({ show, closeLayer, myInfoData }) => {
	return (
		<LayerBottom title="관리자에 의해 활동정지 되어 코멘트를 등록/수정할 수 없어요!" show={show} closeLayer={closeLayer}>
			<ul className="list-item" style={{ fontSize: "1.4rem" }}>
				<li>
					<span>정지일</span>
					<span>{myInfoData && Lib.dateFormat(myInfoData.stopStDe, ".")}</span>
				</li>
				<li>
					<span>정지사유</span>
					<span>{myInfoData && myInfoData.stopRsn}</span>
				</li>
				<li>
					<span>해제일</span>
					<span>{myInfoData && Lib.dateFormat(myInfoData.stopRlsDe, ".")} (D-{myInfoData && Lib.getDday(Lib.GetServerDate(), Lib.ChanageNewDate(myInfoData.stopRlsDe))})</span>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default InfluencerMy
